import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ApplicationAdapter } from 'application/application.adapter';
import { CreateCoacheeUiEventCmd } from 'application/ui-statistics/command/create-coachee-ui-event.cmd';
import { UiStatisticsApiMutationHandler } from 'infrastructure/adapter/ui-statistics/ui-statistics-api-mutation.handler';

@Injectable({ providedIn: 'root' })
export class UiStatisticsCommandHandler extends ApplicationAdapter {
	constructor(
		translateService: TranslateService,
		private _uiStatisticsApiMutationHandler: UiStatisticsApiMutationHandler
	) {
		super(translateService);
	}

	public createCoacheeUiEvent(
		cmd: CreateCoacheeUiEventCmd
	): Observable<void | Error> {
		return this._uiStatisticsApiMutationHandler
			.createCoacheeUiEvent(cmd)
			.pipe(
				catchError(() =>
					of(Error(this._buildInfrastructureErrorMessage('createCoacheeUiEvent')))
				)
			);
	}
}
